
/**
 * 动态路由生成器
 * 根据数据库中的微服务配置动态生成路由
 */
import { RouteConfig } from "./routes";

/**
 * 从微服务配置生成路由配置
 * @param microServices 微服务列表
 * @returns 路由配置数组
 */
export const generateRoutesFromMicroservices = (microServices: any[]): RouteConfig[] => {
  const routes: RouteConfig[] = [];

  // 添加默认的微服务管理页面
  routes.push({
    path: "/services",
    component: "ContainerPage",
    requiresAuth: true,
    description: "微服务管理页面"
  });

  // 为每个微服务生成路由
  microServices.forEach(service => {
    routes.push({
      path: service.routePath || `/${service.name}`,
      component: "ContainerPage",
      requiresAuth: service.requiresAuth !== false,
      description: service.displayName || service.name
    });
  });

  return routes;
};

/**
 * 获取所有需要认证的路由路径
 * @param microServices 微服务列表
 * @returns 需要认证的路由路径数组
 */
export const getAuthenticatedRoutes = (microServices: any[]): string[] => {
  const routes = generateRoutesFromMicroservices(microServices);
  return routes
    .filter(route => route.requiresAuth)
    .map(route => route.path);
};

/**
 * 获取公开路由路径
 * @returns 公开路由路径数组
 */
export const getPublicRoutes = (): string[] => {
  return [
    "/login",
    "/redirect"
  ];
};

/**
 * 根据路径获取路由配置
 * @param path 路径
 * @param microServices 微服务列表
 * @returns 路由配置
 */
export const getRouteConfig = (path: string, microServices: any[]): RouteConfig | undefined => {
  const routes = generateRoutesFromMicroservices(microServices);
  return routes.find(route => route.path === path);
};

/**
 * 检查路径是否需要认证
 * @param path 路径
 * @param microServices 微服务列表
 * @returns 是否需要认证
 */
export const requiresAuth = (path: string, microServices: any[]): boolean => {
  const route = getRouteConfig(path, microServices);
  return route ? route.requiresAuth : false;
};
